import generalSection from "../_section/section.class";
import {userResidencePermitUpload, adminResidencePermitUpload} from "./upload";
import DataForm from "./DataForm";
import dayjs from "dayjs";
import problem from "../_section/section-problem.class";

export class userResidencePermitSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userResidencePermitUpload);
        // Add missing date error

    }
}

export class adminResidencePermitSection extends userResidencePermitSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminResidencePermitUpload);
        this.DataForm = DataForm
        this.sortByDateProp('expiryDate');
        this.activeUpload = this.uploads.find(u => u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.makeProblemsList())
    }

    makeProblemsList() {
        const probs = this.problemsList.singleUploadUserProblems()

        // check if the active uplaod is 3 months from expiry
        const lastestExpiryDateUpload = this.activeUploads.reduce((latest, upload) => {
            const expiryDate = upload.values?.expiryDate;
            if (expiryDate && (!latest || expiryDate.isAfter(latest))) {
                return expiryDate;
            }
            return latest;
        }, null);

        if (lastestExpiryDateUpload && lastestExpiryDateUpload.clone().add(3,'months').isBefore(dayjs())) {
            if (!this.activeUploads.find(u=>!u.isVerifiable)){
                probs.push(new problem({
                    type: 'USER_ALERT',
                    enum: 'CONFIRMATION_OF_EXTENSION_NEEDED',
                    title: 'Confirmation of extension required',
                    uploadIDs: this.uploads.map(u => u.id),
                    body: `As the permit expires within 3 months, we need a copy of the email received from immigration, confirming receipt of the application for extension`
                }))
            }
        }
        return probs;
    }
    get documentDate() {
        return this.activeUpload?.values?.documentDate || null;
    }

    get expiryDate() {
        return this.activeUpload?.values?.expiryDate || null;
    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags: [
                    {
                        name: 'Stamp No',
                        value: this.activeUpload?.values?.stampNumber || 'N/A'
                    },
                    {
                        name: 'Expiry Date',
                        value: this.expiryDate ? this.expiryDate.format('D MMM YYYY') : 'N/A'
                    }
                ]
            }
        ]
    }
}